"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateHumanTags = generateHumanTags;

var _getProperty = require("./getProperty");

var _generateMomentTags = require("./generateMomentTags");

var _ = require("..");

var _tagData = require("./tagData");

var _atoms = require("../atoms");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*
 * Generate human-readable tags for a given moment
 * If the given moment has tags from database those will be used.
 * If no tags are found, the function will generate them.
 * @param {Object} moment - the moment to generate tags for
 * @returns {Array} - an array of human-readable tag objects
 */
function generateHumanTags(moment) {
  // protect against null or undefined
  if (!moment) {
    return [];
  }

  var sport = moment.sport_type ? moment.sport_type : "soccer";
  var tagMap = sport === "soccer" ? _tagData.SOCCER_TAGS : _tagData.BASEBALL_TAGS;
  var tags = [];

  if (!moment.tags) {
    // moment has not tags we need to generate some
    tags = (0, _generateMomentTags.generateMomentTags)(moment);
  } else {
    tags = moment.tags.filter(function (tag) {
      return !["offensive", "middle", "defensive", "offensive to middle", "offensive to defensive", "defensive to middle", "defensive to offensive", "middle to offensive", "middle to defensive"].includes(tag.name);
    });
    tags = tags.concat((0, _generateMomentTags.generateMomentTags)(moment, true));
  }

  var parentObjectOfTeams = moment && moment.meta ? moment.meta : moment;
  var homeSideColor = (0, _getProperty.getProperty)("meta.home_team.color_value", parentObjectOfTeams);
  var awaySideColor = (0, _getProperty.getProperty)("meta.away_team.color_value", parentObjectOfTeams);
  var sideColor = null;
  var homeFound = false;
  var awayFound = false;

  var _iterator = _createForOfIteratorHelper(tags),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var tag = _step.value;

      if (tag.name === "home") {
        sideColor = homeSideColor;
        homeFound = true;
        break;
      }

      if (tag.name === "away" && parentObjectOfTeams.away_team) {
        sideColor = awaySideColor;
        awayFound = true;
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var hTags = [];

  var _iterator2 = _createForOfIteratorHelper(tags),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _tag = _step2.value;
      var mapTag = findMapTag(_tag.name, tagMap);

      if (mapTag && !mapTag.hidden) {
        var _mapTag$title, _mapTag$sort, _mapTag$background, _mapTag$icon;

        var hTag = {
          name: _tag.name,
          title: (_mapTag$title = mapTag.title) !== null && _mapTag$title !== void 0 ? _mapTag$title : _tag.title,
          sort: (_mapTag$sort = mapTag.sort) !== null && _mapTag$sort !== void 0 ? _mapTag$sort : Math.INT_MAX_VALUE,
          background: (_mapTag$background = mapTag.background) !== null && _mapTag$background !== void 0 ? _mapTag$background : null,
          icon: (_mapTag$icon = mapTag.icon) !== null && _mapTag$icon !== void 0 ? _mapTag$icon : null
        };

        switch (hTag.name) {
          case "goal":
          case "key":
          case "box":
            hTag.color = null;
            hTag.background = awayFound ? _atoms.Color.ErrorTint2 : _atoms.Color.ConfirmedTint2;
            hTag.icon = _.Icon.Type.Soccer;
            break;

          case "away-goal":
            hTag.color = null;
            hTag.background = _atoms.Color.ErrorTint2;
            hTag.icon = _.Icon.Type.Soccer;
            break;

          case "home-box":
            hTag.color = homeSideColor;
            break;

          case "away-box":
            hTag.color = awaySideColor;
            break;

          case "packing":
            hTag.title = homeFound ? "progression" : "def breakdown";
            break;
        }

        if (!!hTag.title && hTag.hidden !== true) {
          hTags.push(hTag);
        }
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  hTags = hTags.sort(function (a, b) {
    return parseFloat(a.sort) - parseFloat(b.sort);
  });
  return hTags;
}

function findMapTag(tagName, tagMap) {
  var tn = tagName !== null && tagName !== void 0 ? tagName : "";

  if (tn.startsWith("phone-")) {
    tn = "phone-*";
  }

  if (tn.startsWith("trace-")) {
    tn = "trace-*";
  }

  return tagMap[tn];
}